import { render, staticRenderFns } from "./organizationselector.vue?vue&type=template&id=2bea455a"
import script from "./organizationselector.vue?vue&type=script&lang=js"
export * from "./organizationselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports